import { useTranslation } from 'react-i18next';

import { Footer, HeroBackground, Section, SectionText, SectionTitle } from 'components';

const PrivacyPolicyPage = () => {
    const { t } = useTranslation();

    return (
        <>
            <HeroBackground background={true}>
                <Section hero={true}>
                    <SectionTitle variant='light' title={t('privacy.title')} />
                    <div style={{ whiteSpace: 'pre-line' }}>
                        <SectionText text={t('privacy.content')} />
                    </div>
                </Section>
            </HeroBackground>
            <Footer />
        </>
    )
}

export default PrivacyPolicyPage;